import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import teamPlaceholder from '@assets/images/placeholder/team-placeholder.jpg'
import { getImgURL, numDifferentiation } from '@shared/utils'

const BiddingList = ({ isOpen, bidList, basePrice }) => {
  return (
    <div className={`${styles.list} ${isOpen ? '' : 'd-none'} font-semi text-start`}>
      {bidList?.map((item, index) => {
        return (
          <div key={index} className={`${styles.item} d-flex align-items-center`}>
            <div className={`${styles.teamLogo} br-sm overflow-hidden`}>
              <MyImage
                src={item?.oTeam?.oImg?.sUrl ? getImgURL(item?.oTeam?.oImg?.sUrl) : teamPlaceholder}
                alt={item?.oTeam?.sTitle || 'team'}
                width={120}
                height={120}
                sizes="(max-width: 768px) 40px"
              />
            </div>
            <div className="d-flex align-items-center flex-grow-1 justify-content-between">
              {item?.oTeam?.sTitle}
              {item?.bSold && <span className={`${styles.sold} mx-1`}>SOLD</span>}
              {item?.bRTM && <span className={`${styles.sold} mx-1`}>RTM</span>}
            </div>
            <div className="big-text text-end">{numDifferentiation(item?.nBidPrice)}</div>
          </div>
        )
      })}
      <div className={`${styles.item} d-flex align-items-center`}>
        <div className="d-flex align-items-center flex-grow-1 justify-content-between">Base Price</div>
        <div className="big-text">{basePrice}</div>
      </div>
    </div>
  )
}
BiddingList.propTypes = {
  isOpen: PropTypes.bool,
  bidList: PropTypes.array,
  basePrice: PropTypes.string
}

export default BiddingList
